module.exports = __webpack_public_path__ + "static/media/PragmaticPlay.6f90c397.png";